/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LotDto } from '../../models/lot-dto';
import { Operation } from '../../models/operation';

export interface PatchLot$Params {
  id: number;
  'X-API-Version'?: string;
      body: Array<Operation>
}

export function patchLot(http: HttpClient, rootUrl: string, params: PatchLot$Params, context?: HttpContext): Observable<StrictHttpResponse<LotDto>> {
  const rb = new RequestBuilder(rootUrl, patchLot.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LotDto>;
    })
  );
}

patchLot.PATH = '/api/lots/{id}';
